module.exports = __webpack_public_path__ + "static/img/card-icon.7fbbf2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-icon.png
// module id = PlXg
// module chunks = 20